module.exports = __webpack_public_path__ + "img/search_icon.c3042288.png";